import { message } from "antd";
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { Card, Form, FormGroup, Modal, ModalBody, Spinner } from "reactstrap";
import { AllowAccess } from "../../../components/BlockAccess";
import {
  Block,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Col,
  Icon,
  PaginationComponent,
  RSelect,
} from "../../../components/Component";
import DeleteModal from "../../../components/DeleteModal/DeleteModal";
import { FaqCategoryTable } from "../../../components/table/SpecialTable";
import { authHeader } from "../../../header";
import { useDebounce } from "../../../hooks/useDebounceSearch";
import Content from "../../../layout/content/Content";
import Head from "../../../layout/head/Head";
import { statusOptions } from "../options_common";

export const FaqCategoryManagement = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    status: "",
  });
  const [editId, setEditId] = useState();
  const [isLoadBtn, setIsLoadBtn] = useState(false);
  const [modal, setModal] = useState({ add: false, edit: false, delete: false });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(7);
  const [categories, setCategories] = useState([]);
  const [details, setDetails] = useState();
  const [search, setSearch] = useState("");

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const debouncedSearchTerm = useDebounce(search, 500);

  useEffect(
    () => {
      // if (debouncedSearchTerm) {
      getAllFAQCategory();
      setCurrentPage(1);
      // }v
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [debouncedSearchTerm] // Only call effect if debounced search term changes
  );

  const onEditClick = async (items) => {
    setModal({ edit: true });
    setFormData({
      name: items.name,
      status: items.status,
      description: items.description,
      id: items.id,
    });
    setDetails(items);
    setEditId(items.id);
  };
  const onInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const getAllFAQCategory = async () => {
    try {
      setIsLoading(true);
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/auth/faq-category?platform=TREASURY&search=${search}`,
        {
          headers: authHeader(),
        }
      );
      const { data } = response;
      if (data) {
        setCategories(data.data.body);
        setIsLoading(false);
      }
      return { formData };
    } catch (error) {
      setIsLoading(false);
    }
  };
  const resetForm = () => {
    setFormData({
      name: "",
      description: "",
      status: "",
    });
  };

  const addFaqCategory = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.post(`${process.env.REACT_APP_BASE_URL}/auth/admin/faq-category`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllFAQCategory();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ add: false });
        resetForm();
        message.success("FAQ Category Created Successfully");
      }
      return { formData };
    } catch (error) {
      message.success(error.response.data.message);
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      // return { message };
    }
  };

  const editFaqCategory = async (obj) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.put(`${process.env.REACT_APP_BASE_URL}/auth/admin/faq-category/${editId}`, obj, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllFAQCategory();
        setIsLoadBtn(false);
        setIsLoading(false);
        setModal({ edit: false });
        message.success("FAQ Category Updated Successfully");
        resetForm();
      }
      return { formData };
    } catch (error) {
      const message = error.response;
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ edit: false });
      resetForm();
      return { message };
    }
  };

  const onFormSubmit = () => {
    addFaqCategory({ ...formData, platform: "TREASURY" });
    resetForm();
    setModal({ add: false });
  };

  const deleteCategory = async (id) => {
    try {
      setIsLoadBtn(true);
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/auth/admin/faq-category/${id}`, {
        headers: authHeader(),
      });
      const formData = await response.data;
      if (formData) {
        getAllFAQCategory();
        setIsLoadBtn(false);
        message.success(response.data.message);
        setModal((prev) => ({ ...prev, delete: false }));
      }
      return { formData };
    } catch (error) {
      message.error(error.response.message);
      setIsLoadBtn(false);
      setIsLoading(false);
      setModal({ add: false });
      resetForm();
      // return { message };
    }
  };

  const onDeleteClick = (item) => {
    setModal((prev) => ({ ...prev, delete: true }));
    setDetails(item);
  };

  const handleDelete = async () => {
    deleteCategory(details?.id);
  };

  const onEditSubmit = () => {
    editFaqCategory({ ...formData, platform: "TREASURY" });
    resetForm();
    setModal({ edit: false });
  };

  const onFormCancel = () => {
    setModal({ edit: false, add: false, delete: false });
    resetForm();
  };

  useEffect(() => {
    getAllFAQCategory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = categories?.slice(indexOfFirstItem, indexOfLastItem);

  // Change Page
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const { errors, register, handleSubmit } = useForm();
  return (
    <React.Fragment>
      <Head title="FAQ Category"></Head>
      <Content>
        <Block size="lg">
          <BlockHead>
            <BlockHeadContent>
              <div className="d-flex justify-content-between align-items-center">
                <BlockTitle tag="h4">FAQ Category</BlockTitle>
                <div className="d-flex align-items-center justify-center">
                  <div className="mr-2">
                    <input
                      className="form-control"
                      value={search}
                      onChange={handleSearchChange}
                      placeholder="Search FAQ Category..."
                    />
                  </div>
                  <AllowAccess allowedRights={["CREATE_FAQ_CATEGORY"]}>
                    <Button color="primary" onClick={() => setModal({ add: true })}>
                      <Icon name="plus"></Icon>
                      <span>Create FAQ Category</span>
                    </Button>
                  </AllowAccess>
                </div>
              </div>
            </BlockHeadContent>
          </BlockHead>
          <Card className="card-bordered card-preview">
            {isLoading ? (
              <Spinner
                color="primary"
                style={{
                  height: "3rem",
                  width: "3rem",
                  margin: "0 auto",
                }}
              />
            ) : (
              <FaqCategoryTable
                onDeleteClick={onDeleteClick}
                data={currentItems}
                modal={modal}
                onEditClick={onEditClick}
                onViewClick={() => {}}
              />
            )}
          </Card>
          <div className="card-inner">
            {categories && categories.length > 0 ? (
              <PaginationComponent
                itemPerPage={itemPerPage}
                totalItems={categories?.length}
                paginate={paginate}
                currentPage={currentPage}
              />
            ) : (
              <div className="text-center">
                <span className="text-silent">No Category found</span>
              </div>
            )}
          </div>
        </Block>
        <Modal isOpen={modal.add} toggle={() => setModal({ add: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Add FAQ Category</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onFormSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Category Name</label>
                      <input
                        type="text"
                        name="name"
                        placeholder="Category Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        placeholder="Select Status"
                        options={statusOptions}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        placeholder="description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : "Submit"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>
        <Modal isOpen={modal.edit} toggle={() => setModal({ edit: false })} className="modal-dialog-centered" size="lg">
          <ModalBody>
            <a
              href="#cancel"
              onClick={(ev) => {
                ev.preventDefault();
                onFormCancel();
              }}
              className="close"
            >
              <Icon name="cross-sm"></Icon>
            </a>
            <div className="p-2">
              <h5 className="title">Edit FAQ Category</h5>
              <div className="mt-4">
                <Form className="row gy-4" onSubmit={handleSubmit(onEditSubmit)}>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Category Name</label>
                      <input
                        type="text"
                        name="name"
                        value={formData.name}
                        placeholder="Category Name"
                        onChange={(e) => onInputChange(e)}
                        className="form-control"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.name && <span className="invalid">{errors.name.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col md="6">
                    <FormGroup>
                      <label className="form-label">Status</label>
                      <RSelect
                        placeholder="Select Status"
                        options={statusOptions}
                        value={statusOptions.filter(({ value }) => value === formData.status)[0]}
                        onChange={(e) => setFormData({ ...formData, status: e.value })}
                      />
                      {errors.status && <span className="invalid">{errors.status.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <FormGroup>
                      <label className="form-label">Description</label>
                      <textarea
                        name="description"
                        value={formData.description}
                        placeholder="description"
                        onChange={(e) => onInputChange(e)}
                        className="form-control-xl form-control no-resize"
                        ref={register({
                          required: "This field is required",
                        })}
                      />
                      {errors.description && <span className="invalid">{errors.description.message}</span>}
                    </FormGroup>
                  </Col>
                  <Col size="12">
                    <ul className="align-center flex-wrap flex-sm-nowrap gx-4 gy-2">
                      <li>
                        <Button color="primary" size="md" type="submit">
                          {isLoadBtn ? <Spinner size="sm" /> : "Update"}
                        </Button>
                      </li>
                      <li>
                        <Button
                          onClick={(ev) => {
                            ev.preventDefault();
                            onFormCancel();
                          }}
                          className="link link-light"
                        >
                          Cancel
                        </Button>
                      </li>
                    </ul>
                  </Col>
                </Form>
              </div>
            </div>
          </ModalBody>
        </Modal>

        <DeleteModal
          isOpen={modal.delete}
          onClose={() => setModal((prev) => ({ ...prev, delete: false }))}
          title={details?.name}
          deleteFunc={() => handleDelete()}
          onFormCancel={onFormCancel}
        />
      </Content>
    </React.Fragment>
  );
};
